import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TripleCulture from "@/components/TripleCulture";
import Difference from "@/components/Difference";
import Solutions from "@/components/Solutions";
import Pourquoi from "@/components/Pourquoi";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <TripleCulture />
        <Difference />
        <Solutions />
        <Pourquoi />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
